import { ArrowRight } from 'lucide-react';
import AppMark from './AppMark';

// First-open popup: the app stays visible (blurred) behind it. Tapping a
// use-case card drops the user straight into that tab; the backdrop or
// "Get started" simply dismisses.
const Onboarding = ({ onStart }) => (
  <div
    className="fixed inset-0 z-50 flex items-end sm:items-center justify-center"
    role="dialog"
    aria-modal="true"
    aria-label="What this app does"
  >
    <button
      type="button"
      aria-label="Dismiss"
      onClick={() => onStart()}
      className="absolute inset-0 bg-slate-400/25"
    />

    <div className="relative w-full max-w-md bg-white rounded-t-[30px] sm:rounded-[30px] px-5 pt-7 pb-6 sm:px-7 sm:mx-6 shadow-2xl shadow-slate-900/25">
      <div className="flex items-center gap-3.5">
        <AppMark size={52} />
        <div>
          <h1 className="text-[22px] font-semibold tracking-tight leading-tight">
            Your transcript, two answers.
          </h1>
        </div>
      </div>
      <p className="mt-3 text-slate-500 text-[15px] leading-relaxed">
        Made for USP students on SOLS. No accounts, nothing leaves your phone.
      </p>

      <div className="mt-5 space-y-3">
        <button
          type="button"
          onClick={() => onStart('gpa')}
          className="w-full text-left rounded-3xl bg-gradient-to-b from-graphite-900/95 to-graphite-700/90 border border-white/10 p-5 text-white active:scale-[0.99] transition-transform"
        >
          <p className="text-mint-200 text-[11px] font-semibold tracking-[0.16em] uppercase">
            What&apos;s my GPA?
          </p>
          <p className="mt-1.5 text-[17px] font-semibold leading-snug">
            Drop in a SOLS screenshot, get your GPA in seconds.
          </p>
          <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-mint-200">
            Calculate GPA <ArrowRight className="w-4 h-4" />
          </span>
        </button>

        <button
          type="button"
          onClick={() => onStart('target')}
          className="w-full text-left rounded-3xl bg-gradient-to-b from-graphite-900/95 to-graphite-700/90 border border-white/10 p-5 text-white active:scale-[0.99] transition-transform"
        >
          <p className="text-gold-300 text-[11px] font-semibold tracking-[0.16em] uppercase">
            What do I need on the final?
          </p>
          <p className="mt-1.5 text-[17px] font-semibold leading-snug">
            See the exam mark that gets you each grade.
          </p>
          <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-gold-300">
            Plan my final <ArrowRight className="w-4 h-4" />
          </span>
        </button>
      </div>

      <button
        type="button"
        onClick={() => onStart()}
        className="mt-5 w-full rounded-full bg-slate-900 text-white font-semibold py-3.5 text-[15px] active:scale-[0.99] transition-transform"
      >
        Get started
      </button>
    </div>
  </div>
);

export default Onboarding;
